import { Link } from "react-router-dom";
import { KEY_NAME } from "../../utils/KeyName";
import "./PageNotFound.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuildingColumns,
  faFileLines,
  faChartColumn,
} from "@fortawesome/free-solid-svg-icons";

const PageNotFound = () => {
  return (
    <div className="not-found container py-5 d-flex flex-column align-items-center justify-content-center">
      <div className="text-center w-100" style={{ maxWidth: "850px" }}>
        <h1 className="display-1 fw-bold text-muted opacity-25 mb-0">404</h1>
        <h2 className="h3 fw-semibold text-dark mb-3">Page Not Found</h2>
        <p className="text-muted mb-5 px-md-5">
          We couldn't find the page you're looking for. It might have been
          moved, or the link may be broken. Please contact CHORUS Staff at{" "}
          <span
            className="text-primary text-decoration-underline"
            style={{ cursor: "text" }}
          >
            info@chorusaccess.org
          </span>
        </p>
        {/* <p className="text-muted mb-5 px-md-5">
          We couldn't find the page you're looking for. It might have been
          moved, or the link may be broken. Let's get you back to your
          data—select your dashboard below.
        </p> */}

        {/* <div className="row g-4 justify-content-center">
          <div className="col-12 col-md-4">
            <Link
              to={`/${KEY_NAME.FUNDER}`}
              className="card dashboard-card text-decoration-none h-100"
            >
              <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                <h3 className="h6 fw-semibold mb-0 text-dark card-title">
                  Funders Dashboard
                </h3>
              </div>
            </Link>
          </div>

          <div className="col-12 col-md-4">
            <Link
              to={`/${KEY_NAME.PUBLISHER}`}
              className="card dashboard-card text-decoration-none h-100"
            >
              <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                <h3 className="h6 fw-semibold mb-0 text-dark card-title">
                  Publishers Dashboard
                </h3>
              </div>
            </Link>
          </div>

          <div className="col-12 col-md-4">
            <Link
              to={`/${KEY_NAME.INSTITUTION}`}
              className="card dashboard-card text-decoration-none h-100"
            >
              <div className="card-body d-flex flex-column align-items-center justify-content-center p-4">
                <h3 className="h6 fw-semibold mb-0 text-dark card-title">
                  Institutions Dashboard
                </h3>
              </div>
            </Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PageNotFound;
